module.exports = __webpack_public_path__ + "img/solestage_qrcode_android.ff3289dd.png";